import BetterSmile from '../../../common/icons/BetterSmile';
import CavityFree from '../../../common/icons/CavityFree';
import CleanerMouth from '../../../common/icons/CleanerMouth';
import FreshBreath from '../../../common/icons/FreshBreath';
import HealthyGums from '../../../common/icons/HealthyGums';
import WhiterTeeth from '../../../common/icons/WhiterTeeth';

export const options = [
  {
    id: 'cleaner-mouth',
    title: 'Cleaner mouth',
    icon: CleanerMouth,
  },
  {
    id: 'whiter-teeth',
    title: 'Whiter teeth',
    icon: WhiterTeeth,
  },
  {
    id: 'fresher-breath',
    title: 'Fresher Breath',
    icon: FreshBreath,
  },
  {
    id: 'cavity-free-teeth',
    title: 'Cavity-free teeth',
    icon: CavityFree,
  },
  {
    id: 'healthier-gums',
    title: 'Healthier gums',
    icon: HealthyGums,
  },
  {
    id: 'better-smile',
    title: 'Better smile',
    icon: BetterSmile,
  },
];
